import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointService } from './endpoint.service';
import { BaseResponse } from '../responses/BaseResponse';
import { AddSupportMessageRequest } from '../requests/AddSupportMessageRequest';
import { PaymentHistory } from '../models/payment-history';
import { BehaviorSubject } from 'rxjs';
import {GetProviderResponse} from "../responses/GetProviderResponse";

@Injectable()
export class BenefitDetailsService {
  constructor(private http: HttpClient) {}
  private paymentHistory = new BehaviorSubject<PaymentHistory>(
    null
  );
  public newPaymentHistory = this.paymentHistory.asObservable();

  editPaymentHistory(value) {
    // eslint-disable-next-line no-debugger
    this.paymentHistory.next(value);
  }

  addSupportMessage(data: AddSupportMessageRequest) {
    return this.http.post<BaseResponse>(
      EndpointService.addSupportMessage,
      data
    );
  }

  getProviderById(id: number) {
    return this.http.get<GetProviderResponse>(EndpointService.getProviderById(id));
  }
}
